/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { createPreloadLoginFn } from "abreact/incubator/ui/login/PreloadLoginManager";
import { ReactUILoginHelper } from "abreact/incubator/ui/login/ReactUILoginHelper";
import { AbReactServicesInitializer } from "abreact/service/AbReactServicesInitializer";
import { StatefulServerAuthenticationStrategy } from "abreact/service/authentication/StatefulServerAuthenticationStrategy";
import { AbWebServicesInitializer } from "abweb/service/AbWebServicesInitializer";
import { AuthenticationWorkflow } from "abweb/service/app/AuthenticationWorkflow";
export async function reactAuthenticationStrategy(alProps, requiredLoginRole, preloadSpecs, loginDlgShowProductName = true, loginDlgAlternateLoginImage, alwaysPreloadLastSpec = false, abWebServicesConfig = {
  authenticationStrategy: new StatefulServerAuthenticationStrategy()
}, abReactServicesConfig = {}, preAuthHook, portalLoginView) {
  // 1. Initialize services needed to fully support this react-based auth workflow
  const {
    profileStartup
  } = alProps;
  await initializeReactAuthorizationServices(alProps, abWebServicesConfig, abReactServicesConfig);

  // 1.1 Invoke pre-auth hook if it is defined
  if (preAuthHook) {
    await preAuthHook(alProps);
  }

  // 2. Calculate whether loginFn should preload modules in background while login dialog is displayed
  let loginDlgs = new ReactUILoginHelper(portalLoginView);
  const showLoginFn = preloadSpecs.length > 0 ? createPreloadLoginFn(loginDlgs.showLoginFn, alProps, preloadSpecs, alwaysPreloadLastSpec) : loginDlgs.showLoginFn;

  // 3. Start auth initialization workflow which will fully authenticate user (stays in workflow until user successfully authenticated)
  profileStartup("Initializing AuthenticationServiceInitializer");
  const authServiceInit = new AuthenticationWorkflow(alProps, requiredLoginRole, showLoginFn, loginDlgs.showAccessDeniedDlgFn, loginDlgs.showSplashScreenFn);
  const success = await authServiceInit.authenticate();
}

// Minimal set of libraries needed for react-based dialogs in an abweb-based AuthorizationWorkflow is abweb and abreact
async function initializeReactAuthorizationServices(alProps, abWebServicesConfig, abReactServicesConfig) {
  alProps.profileStartup("Initializing AbWebServices");
  await AbWebServicesInitializer.initDefaultServices(abWebServicesConfig);
  alProps.profileStartup("Initializing AbReactServices");
  await AbReactServicesInitializer.initDefaultServices(abReactServicesConfig);
  // Do NOT configure ReactErrorRenderer when !headless - BootstrapApp error handling during app initialization relies on this not being set,
  // and if successful app initialization then BootstrapApp will set it.
}
//# sourceMappingURL=ReactAuthenticationStrategy.js.map
